import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Badge } from "@/components/ui/badge";
import { toast } from "sonner";
import { Search, Trash2, MessageSquare } from "lucide-react";

export default function AdminChatHistory() {
  const [q, setQ] = useState("");
  const [data, setData] = useState({ messages: [], count: 0, sessions: 0 });
  const [loading, setLoading] = useState(true);
  const [bump, setBump] = useState(0);

  useEffect(() => {
    setLoading(true);
    api.get("/admin/chat-history", { params: { q } })
      .then((r) => setData(r.data))
      .finally(() => setLoading(false));
  }, [q, bump]);

  const remove = async (id) => {
    try {
      await api.delete(`/admin/chat-history/${id}`);
      toast.success("Üzenet törölve");
      setBump((b) => b + 1);
    } catch {
      toast.error("Nem sikerült törölni");
    }
  };

  return (
    <div className="space-y-6" data-testid="admin-chat-history">
      <div>
        <p className="section-label">Chat előzmények</p>
        <h1 className="text-2xl sm:text-3xl font-bold text-[#201B18] mt-1">
          {data.count} kérdés · {data.sessions} beszélgetés
        </h1>
        <p className="text-sm text-[#8C8075] mt-2">A látogatók „Ask GrowBag” kérdései – ideális alapanyag a GYIK építéséhez.</p>
      </div>

      <div className="relative">
        <Search className="h-4 w-4 absolute left-3 top-1/2 -translate-y-1/2 text-[#8C8075]" />
        <Input placeholder="Keresés a kérdésekben, válaszokban..." value={q} onChange={(e) => setQ(e.target.value)} data-testid="admin-chat-search" className="pl-9" />
      </div>

      <div className="space-y-3" data-testid="admin-chat-list">
        {loading ? (
          <p className="text-center text-[#8C8075] py-10">Betöltés...</p>
        ) : data.messages.length === 0 ? (
          <p className="text-center text-[#8C8075] py-10" data-testid="admin-chat-empty">Még nincs chat üzenet.</p>
        ) : (
          data.messages.map((m) => (
            <div key={m.id} className="rounded-2xl bg-white border border-[#2C221E]/10 p-4 sm:p-5" data-testid={`admin-chat-item-${m.id}`}>
              <div className="flex items-start justify-between gap-3 mb-3">
                <div className="flex flex-wrap items-center gap-2 text-xs text-[#8C8075]">
                  <span>{new Date(m.created_at).toLocaleString("hu-HU")}</span>
                  <Badge className="bg-[#EAF0EC] text-[#3B5843] border-[#4A6B53]/30 font-mono-brand text-[10px]">{m.model}</Badge>
                  <span className="font-mono-brand text-[10px] truncate max-w-[180px]">{m.session_id}</span>
                </div>
                <button onClick={() => remove(m.id)} data-testid={`admin-chat-delete-${m.id}`} className="text-[#8C8075] hover:text-red-600 shrink-0" aria-label="Törlés">
                  <Trash2 className="h-4 w-4" />
                </button>
              </div>
              <div className="flex gap-3">
                <MessageSquare className="h-4 w-4 mt-1 text-[#8B4A2E] shrink-0" />
                <p className="font-semibold text-[#201B18]">{m.question}</p>
              </div>
              <p className="mt-2 ml-7 text-sm text-[#5C524A] whitespace-pre-wrap">{m.reply}</p>
            </div>
          ))
        )}
      </div>
    </div>
  );
}
